window.onload = function() {
  // console.log('document - onload'); // Uncomment for debugging

  function clickButtonInShadowDOM() {
    const shadowHosts = document.querySelectorAll("*"); // Broad selection
    shadowHosts.forEach((host) => {
      if (host.shadowRoot) {
        const button = host.shadowRoot.querySelector(
          ".Launcherstyled__LauncherButtonWrapper-ch-front__sc-1kx6op4-0 button"
        );
        if (button) {
          button.click();
          // console.log("Button clicked"); // Uncomment for debugging
          return; // Exit the function after clicking the button
        }
      }
    });
  }

  setTimeout(function() {
    // Add event listeners to the specified elements
    const footerBtnItem = document.querySelector(".footer-top .item:nth-child(2) a");
    if (footerBtnItem) {
      footerBtnItem.addEventListener("click", () => {
        clickButtonInShadowDOM();
      });
    }
    const btnItem = document.querySelector("p.btn_item.btn02.c_grd:nth-child(2) a");
    if (btnItem) {
      btnItem.addEventListener("click", () => {
        clickButtonInShadowDOM();
      });
    }

    const menuContactItem = document.querySelector(".menu-contact .item:nth-child(2) a");
    if (menuContactItem) {
      menuContactItem.addEventListener("click", () => {
        clickButtonInShadowDOM();
      });
    }
  }, 3000);
};
